/* @generated */

// ../src/card/container.tsx
import * as React from "react";
import { useEventListener } from "@react-hookz/web";
import clsx from "classnames";
import "focus-visible";

// ../src/card/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var card = "dig-1vg36k1c_21-7-0";
var cardActions = "dig-1vg36k11d_21-7-0";
var cardContainer = _7a468({ defaultClassName: "dig-1vg36k1k_21-7-0", variantClassNames: { hasBorders: { true: "dig-1vg36k1l_21-7-0" }, isBorderOnContainer: { true: "dig-1vg36k1m_21-7-0" }, isSelected: { true: "dig-1vg36k1n_21-7-0" }, isLink: { true: "dig-1vg36k1o_21-7-0" }, isHover: { true: "dig-1vg36k1p_21-7-0" }, isActive: { true: "dig-1vg36k1q_21-7-0" }, isFocus: { true: "dig-1vg36k1r_21-7-0" }, hasFocus: { true: "dig-1vg36k1s_21-7-0" }, hasFocusVisible: { true: "dig-1vg36k1t_21-7-0" }, isDisabled: { true: "dig-1vg36k1u_21-7-0" }, isFocusWithin: { true: "dig-1vg36k1v_21-7-0" }, borderRadius: { XSmall: "dig-1vg36k1w_21-7-0", Small: "dig-1vg36k1x_21-7-0", Medium: "dig-1vg36k1y_21-7-0", Large: "dig-1vg36k1z_21-7-0", XLarge: "dig-1vg36k110_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cardContent = "dig-1vg36k112_21-7-0";
var cardContentPadding = "var(--dig-1vg36k15_21-7-0)";
var cardInner = "dig-1vg36k111_21-7-0";
var cardLink = _7a468({ defaultClassName: "dig-1vg36k1a_21-7-0", variantClassNames: { isOverlay: { true: "dig-1vg36k1b_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cardMedia = _7a468({ defaultClassName: "dig-1vg36k116_21-7-0", variantClassNames: { hasBottomBorder: { true: "dig-1vg36k117_21-7-0" }, isOverflowHidden: { true: "dig-1vg36k118_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cardMediaGridArea1 = "var(--dig-1vg36k16_21-7-0)";
var cardMediaGridArea2 = "var(--dig-1vg36k17_21-7-0)";
var cardMediaGridArea3 = "var(--dig-1vg36k18_21-7-0)";
var cardMediaGridArea4 = "var(--dig-1vg36k19_21-7-0)";
var cardMediaLayoutAutoGrid = "dig-1vg36k11c_21-7-0";
var cardMediaOverlaySlot = _7a468({ defaultClassName: "dig-1vg36k11a_21-7-0", variantClassNames: { hasOverlay: { true: "dig-1vg36k11b_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cardMediaRatio = "dig-1vg36k119_21-7-0";
var cardScrim = _7a468({ defaultClassName: "dig-1vg36k113_21-7-0", variantClassNames: { isVisible: { true: "dig-1vg36k114_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cardScrimThemeMod = "dig-1vg36k115_21-7-0";
var cardSection = _7a468({ defaultClassName: "dig-1vg36k1d_21-7-0", variantClassNames: { background: { Subtle: "dig-1vg36k1e_21-7-0", Raised: "dig-1vg36k1f_21-7-0", Base: "dig-1vg36k1g_21-7-0", Transparent: "dig-1vg36k1h_21-7-0", "Selection Surface": "dig-1vg36k1i_21-7-0" }, relative: { true: "dig-1vg36k1j_21-7-0" } }, defaultVariants: { background: "Raised" }, compoundVariants: [] });

// ../src/card/container.tsx
function containsRelatedTarget(event) {
  if (event.currentTarget instanceof HTMLElement && event.relatedTarget instanceof HTMLElement) {
    return event.currentTarget.contains(event.relatedTarget);
  }
  return false;
}
var Container = React.forwardRef(
  ({
    children,
    _pseudoClass,
    isSelected,
    className,
    isDisabled,
    isLink,
    isFocusWithin,
    onFocusWithin,
    onBlurWithin,
    tagName: TagName = "div",
    focusBehavior = "none",
    hasBorders = true,
    borderRadius,
    ...rest
  }, ref) => {
    const containerRef = React.useRef(null);
    const isFocused = React.useRef(false);
    const handleFocusIn = (event) => {
      if (!isFocused.current) {
        isFocused.current = true;
        onFocusWithin && onFocusWithin(event);
      }
    };
    const handleFocusOut = (event) => {
      if (isFocused.current && !containsRelatedTarget(event)) {
        isFocused.current = false;
        onBlurWithin && onBlurWithin(event);
      }
    };
    useEventListener(containerRef, "focusin", handleFocusIn);
    useEventListener(containerRef, "focusout", handleFocusOut);
    React.useImperativeHandle(ref, () => {
      return {
        focus: (options) => {
          if (!containerRef.current) return;
          return containerRef.current.focus(options);
        },
        getBoundingClientRect: () => {
          if (!containerRef.current) return;
          return containerRef.current.getBoundingClientRect();
        }
      };
    });
    return /* @__PURE__ */ React.createElement(
      TagName,
      {
        ref: containerRef,
        className: clsx(
          "dig-Card",
          "dig-Card-Container",
          className,
          {
            "dig-Card-Container--active": _pseudoClass === "active",
            "dig-Card-Container--hover": _pseudoClass === "hover",
            "dig-Card-Container--focus": _pseudoClass === "focus",
            "dig-Card-Container--has-focus": focusBehavior === "focus",
            "dig-Card-Container--has-focus-visible": focusBehavior == "focus-visible",
            "dig-Card-Container--selected": isSelected,
            "dig-Card-Container--disabled": isDisabled,
            "dig-Card-Container--link": isLink,
            "dig-Card-Container--focusWithin": isFocusWithin,
            "dig-Card-Container--has-borders": hasBorders
          },
          card,
          cardContainer({
            isActive: _pseudoClass === "active",
            isHover: _pseudoClass === "hover",
            isFocus: _pseudoClass === "focus",
            hasFocus: focusBehavior === "focus",
            hasFocusVisible: focusBehavior == "focus-visible",
            isSelected,
            isDisabled,
            isLink,
            isFocusWithin,
            hasBorders,
            borderRadius,
            // Maintain the border on the container if the border radius is not set.
            isBorderOnContainer: !borderRadius
          })
        ),
        "aria-disabled": isDisabled,
        tabIndex: focusBehavior === "none" ? void 0 : 0,
        ...rest
      },
      borderRadius ? /* @__PURE__ */ React.createElement("div", { className: cardInner }, children) : children
    );
  }
);

// ../src/card/content.tsx
import * as React4 from "react";
import clsx3 from "classnames";

// ../src/card/section.tsx
import * as React2 from "react";
import clsx2 from "classnames";
var classifyRegex = /\s+/g;
function cssClassify(rawClass) {
  return rawClass.replace(classifyRegex, "-").toLowerCase();
}
var Section = React2.forwardRef(
  ({ children, className, hasOverlay, order, style, backgroundColor = "Raised", ...rest }, ref) => {
    const localRef = React2.useRef(null);
    React2.useImperativeHandle(ref, () => {
      return {
        focus: (options) => {
          if (!localRef.current) return;
          return localRef.current.focus(options);
        },
        getBoundingClientRect: () => {
          if (!localRef.current) return;
          return localRef.current.getBoundingClientRect();
        }
      };
    });
    const styles = { ...style, order };
    return /* @__PURE__ */ React2.createElement(
      "div",
      {
        className: clsx2(
          "dig-Card__section",
          {
            "dig-Card__section--relative": hasOverlay,
            [`dig-Card__section--background-color-${cssClassify(backgroundColor)}`]: backgroundColor
          },
          cardSection({
            background: backgroundColor,
            relative: hasOverlay
          }),
          className
        ),
        ...rest,
        style: styles,
        ref: localRef
      },
      children
    );
  }
);

// ../src/_global/useCustomSpacing.tsx
import * as React3 from "react";
var addStyleIfDefined = (styling, styleName, ...args) => {
  const validStyleValue = args.find((arg) => arg !== void 0);
  if (validStyleValue === void 0) {
    return styling;
  }
  return {
    ...styling,
    [styleName]: validStyleValue
  };
};
var useCustomSpacing = ({
  padding,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingY,
  paddingX
}) => {
  return React3.useMemo(() => {
    let styling = {};
    styling = addStyleIfDefined(styling, "padding", padding);
    styling = addStyleIfDefined(styling, "paddingLeft", paddingX, paddingLeft);
    styling = addStyleIfDefined(styling, "paddingRight", paddingX, paddingRight);
    styling = addStyleIfDefined(styling, "paddingTop", paddingY, paddingTop);
    styling = addStyleIfDefined(styling, "paddingBottom", paddingY, paddingBottom);
    return styling;
  }, [padding, paddingBottom, paddingLeft, paddingRight, paddingTop, paddingX, paddingY]);
};

// ../src/card/content.tsx
import { assignInlineVars } from "@vanilla-extract/dynamic";
var SPACING_MAP = {
  xsmall: "var(--dig-spacing__dimension__8)",
  small: "var(--dig-spacing__dimension__12)",
  medium: "var(--dig-spacing__dimension__16)",
  large: "var(--dig-spacing__dimension__20)"
};
var spacingDecider = (paddingAlias) => {
  return SPACING_MAP[paddingAlias];
};
var Content = ({
  children,
  spacing = "xsmall",
  padding,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  paddingX,
  paddingY,
  className,
  hasOverlay,
  backgroundColor = "Raised",
  style,
  ...rest
}) => {
  const spacingStyles = useCustomSpacing({
    padding,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    paddingX,
    paddingY
  });
  const styl = {
    ...assignInlineVars({ [cardContentPadding]: spacingDecider(spacing) }),
    ...spacingStyles,
    ...style
  };
  return /* @__PURE__ */ React4.createElement(
    Section,
    {
      className: clsx3("dig-Card-Content", cardContent, className),
      style: styl,
      hasOverlay,
      backgroundColor,
      ...rest
    },
    children
  );
};

// ../src/card/media.tsx
import * as React5 from "react";
import clsx4 from "classnames";
import { AspectRatio } from "@dropbox/dig-components/aspect_ratio";
var Media = ({
  children,
  ratio = 1,
  minHeight,
  maxHeight,
  withOverlay,
  allowOverflow = false,
  hasBottomBorder,
  backgroundColor = "Subtle",
  ...rest
}) => {
  return /* @__PURE__ */ React5.createElement(
    Section,
    {
      className: clsx4(
        "dig-Card-Media",
        {
          "dig-Card-Media--overflow-hidden": !allowOverflow,
          "dig-Card-Media--has-bottom-border": hasBottomBorder
        },
        cardMedia({ isOverflowHidden: !allowOverflow, hasBottomBorder })
      ),
      hasOverlay: Boolean(withOverlay),
      backgroundColor,
      ...rest
    },
    /* @__PURE__ */ React5.createElement(
      AspectRatio,
      {
        className: clsx4("dig-Card-Media__ratio", cardMediaRatio),
        ratio,
        minHeight,
        maxHeight
      },
      children
    ),
    /* @__PURE__ */ React5.createElement(
      "div",
      {
        className: clsx4(
          "dig-Card-Media__overlay-slot",
          {
            "dig-Card-Media__overlay-slot--has-overlay": !!withOverlay
          },
          cardMediaOverlaySlot({ hasOverlay: !!withOverlay })
        )
      },
      withOverlay
    )
  );
};

// ../src/card/link.tsx
import * as React6 from "react";
import clsx5 from "classnames";
var defaultElement = "a";
var Link = (props) => {
  const { as: Component = defaultElement, children, className, isOverlay, ...rest } = props;
  return /* @__PURE__ */ React6.createElement(
    Component,
    {
      className: clsx5(
        "dig-Card-Link",
        className,
        { "dig-Card-Link--is-overlay": isOverlay },
        cardLink({ isOverlay })
      ),
      ...rest,
      "data-dig-is-overlay-link": isOverlay
    },
    children
  );
};

// ../src/card/media_layout.tsx
import * as React8 from "react";
import clsx6 from "classnames";

// ../src/utils.ts
import * as React7 from "react";
function invariant(condition, message) {
  if (condition) return;
  throw new Error(`dig-components - Invariant: ${message}`);
}

// ../src/card/media_layouts/auto_grid.ts
import cls from "classnames";
import { assignInlineVars as assignInlineVars2 } from "@vanilla-extract/dynamic";
var AUTO_GRID_LAYOUTS = {
  1: assignInlineVars2({ [cardMediaGridArea1]: "1 / 1 / 3 / 3" }),
  2: assignInlineVars2({
    [cardMediaGridArea1]: "1 / 1 / 3 / 2",
    [cardMediaGridArea2]: "1 / 2 / 3 / 3"
  }),
  3: assignInlineVars2({
    [cardMediaGridArea1]: "1 / 1 / 3 / 2",
    [cardMediaGridArea2]: "1 / 2 / 2 / 3",
    [cardMediaGridArea3]: "2 / 2 / 3 / 3"
  }),
  4: assignInlineVars2({
    [cardMediaGridArea1]: "1 / 1 / 2 / 2",
    [cardMediaGridArea2]: "1 / 2 / 2 / 3",
    [cardMediaGridArea3]: "2 / 1 / 3 / 2",
    [cardMediaGridArea4]: "2 / 2 / 3 / 3"
  })
};
var autoGridLayout = ({ totalChildren }) => {
  invariant(
    totalChildren <= 4,
    `The auto-grid layout only supports 1-4 children. Received ${totalChildren} children. If you need more
    than 4 children, you'll need to use your own component.`
  );
  return {
    style: AUTO_GRID_LAYOUTS[totalChildren],
    className: cls("dig-Card-Media-Layout--auto-grid", cardMediaLayoutAutoGrid)
  };
};

// ../src/card/media_layouts/index.ts
var layoutsMap = {
  "auto-grid": autoGridLayout
};

// ../src/card/media_layout.tsx
var availableLayouts = () => Object.keys(layoutsMap).join(", ");
var MediaLayout = ({ children, layout, ...rest }) => {
  invariant(
    layout in layoutsMap,
    `Unknown layout: ${layout}. The available layouts are: ${availableLayouts()}`
  );
  const { className, style } = layoutsMap[layout]({ totalChildren: React8.Children.count(children) });
  return /* @__PURE__ */ React8.createElement(Media, { ...rest }, /* @__PURE__ */ React8.createElement("div", { className: clsx6("dig-Card-Media-Layout", className), style }, children));
};

// ../src/card/actions.tsx
import * as React9 from "react";
import clsx7 from "classnames";
var Actions = ({ children, className, ...rest }) => {
  return /* @__PURE__ */ React9.createElement("div", { className: clsx7("dig-Card-Actions", cardActions, className), ...rest }, children);
};

// ../src/card/scrim.tsx
import * as React10 from "react";
import clsx8 from "classnames";
import { ThemeProvider } from "@dropbox/dig-foundations";
var Scrim = ({ isVisible, children }) => {
  const cls2 = clsx8(
    "dig-Card-Scrim",
    {
      "dig-Card-Scrim--isVisible": isVisible
    },
    cardScrim({ isVisible })
  );
  return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement("div", { className: cls2 }), isVisible ? /* @__PURE__ */ React10.createElement(ThemeProvider, { mode: "dark" }, ({ getThemeProps }) => /* @__PURE__ */ React10.createElement(
    "span",
    {
      ...getThemeProps({ className: clsx8("dig-Card-Scrim__theme-mode", cardScrimThemeMod) })
    },
    children
  )) : children);
};

// ../src/card/card.ts
var CardNamespace = Object.assign(Container, {
  Content,
  Media,
  Link,
  Section,
  MediaLayout,
  Actions,
  Scrim
});
export {
  CardNamespace as Card
};
